/* Bootstrap */

import {
  // Alert,       // Dismissible alerts
  // Button,      // Toggle button states
  // Carousel,    // Slideshow component
  Collapse, // Accordion-like collapsing elements
  // Dropdown,    // Dropdown menus
  // Modal,       // Popup modals
  // Offcanvas,   // Offcanvas sidebars
  // Popover,     // Pop-up content on hover/click (requires @popperjs/core)
  // ScrollSpy,   // Auto-updating navigation based on scroll position
  // Tab,         // Tabs and pills navigation
  // Toast,       // Small pop-up notifications
  // Tooltip      // Tooltips for elements (requires @popperjs/core)
} from "bootstrap";

/* Custom SCSS */
// import "./index.scss";
// import './style-login.scss';
// import './style-admin.scss';
// import './style-buttons.scss';

/* Swiper */

import Swiper from "swiper/bundle";
import "swiper/css/bundle";

window.Swiper = Swiper;

/* Gsap */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { TextPlugin } from "gsap/TextPlugin";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

gsap.registerPlugin(ScrollTrigger, TextPlugin, DrawSVGPlugin);
window.gsap = gsap;

import massimo from "./js/massimo";
massimo();

import navbar from "./js/navbar";
navbar();

import footer from "./js/footer";
footer();

import sidebar from "./js/sidebar";
sidebar();

import search from "./js/search";
search();

// import woocommerce from "./js/woocommerce";
// woocommerce();

import scrollTop from "./js/scrollTop";
scrollTop();

import textCarousel from "./js/blocks/textCarousel";
textCarousel();

import services from "./js/blocks/services";
services();

import pubblicazioni from "./js/blocks/pubblicazioni";
pubblicazioni();

import heroHome from "./js/blocks/heroHome.js";
heroHome();

import btns from "./js/blocks/btns.js";
btns();

import accordions from "./js/blocks/accordions.js";
accordions();

import single from "./js/single.js";
single();

import blog from "./js/blog.js";
blog();
